import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import LoadingIcon from "./LoadingIcon";

export default function LoadingModal({ onCancel }) {
	return <Dialog
		open={true}
		disableBackdropClick
	>
		<DialogTitle>{(window as any).qdesk.strings.loading + "..."}</DialogTitle>
		<DialogContent>
			<div style={{
				textAlign: "center", margin: "14px 100px" }}><LoadingIcon /></div>
		</DialogContent>
		<DialogActions>
			<Button onClick={(e) => onCancel()} color="default" variant="contained">
				{(window as any).qdesk.strings.cancel}
			</Button>
		</DialogActions>
	</Dialog>
}